import React from 'react';

function CourseMenu({ courseData, hasChapters, onPageLinkClick }) {

    if (!courseData || !hasChapters) {
        return <></>;
    }

    return (
        <div className="w-1/6 bg-gray-200 p-4 overflow-y-auto">
            <h2 className="text-lg font-bold">Course Details</h2>
            <ul className="mt-4 space-y-2">
                <li style={{ fontWeight: "bold" }}>
                    <input type="checkbox" /> {courseData.title}
                </li>
                {
                    courseData.content && courseData.content.map((item, index) => {
                        return (
                            <li key={index}>
                                <input type="checkbox" /> {item.title}
                                <ul className="ml-4 space-y-1">
                                    {
                                        item.items ? item.items.map((element, subIndex) => {
                                            if (element.href) {
                                                const courseHref = element.href + (element.parameters || "");

                                                return (
                                                    <li key={subIndex}>
                                                        <input type="checkbox" />
                                                        <span className='clickable-item' onClick={() => onPageLinkClick(courseHref)}>{element.title}</span>
                                                    </li>
                                                );
                                            } else {
                                                return (
                                                    <li key={subIndex}>
                                                        <input type="checkbox" /> {element.title}
                                                    </li>
                                                );
                                            }
                                        }) : <div>
                                            <li key="item_ref">
                                                <input type="checkbox" />
                                                <span className='clickable-item' onClick={() => onPageLinkClick(item.href + (item.parameters || ''))}>{item.title}</span>
                                            </li>
                                        </div>
                                    }
                                </ul>
                            </li>
                        );
                    })
                }
            </ul>
        </div>
    );
}

export default CourseMenu;
